import { render, staticRenderFns } from "./dashboardUpdateItem.vue?vue&type=template&id=3f3d2114&scoped=true&lang=html&"
import script from "./dashboardUpdateItem.vue?vue&type=script&lang=js&"
export * from "./dashboardUpdateItem.vue?vue&type=script&lang=js&"
import style0 from "./dashboardUpdateItem.vue?vue&type=style&index=0&id=3f3d2114&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3d2114",
  null
  
)

export default component.exports